export const FILTER_RESET_VALUES: any = {
  appliedDate: [null, null],
  updatedDate: [null, null],
  merchant: [],
  provider: [],
  gateway: [],
  method: [],
  category: null,
  providerExternalError: { isCritical: null, reason: null },
  order: { direction: null, gateway: null },
  timezone: null,
};
